/* eslint-disable react/prop-types */
import React from "react";
import axios from "axios";
import FadeIn from "../../common/FadeIn";
//Bootstrap
import { Table, Col, Row, Button } from "react-bootstrap";
//TimeRendering
import Moment from "react-moment";
//Images and Icons
import { MdCreditCard } from "react-icons/md";

const PayYourInvoce = (props) => {
  const unpaidInvoicesList = props.invoices.filter((e) => e.status === "open" && e.attempted);
  const currencySymbol = props.currencySymbol;
  const handleCardChangeAndPay = async (subscriptionID, invoiceID, e) => {
    e.preventDefault();
    const data = {
      subscriptionID,
      invoiceID,
    };
    props.setSubmitClicked(true);
    const requestCardChangeAndPay = await axios.post(
      `/api/customer/manage_session/change_card_details_and_pay/`,
      data,
      {
        withCredentials: true,
      }
    );

    if (requestCardChangeAndPay.status === 200) {
      props.setSubmitClicked(false);
      return (window.location.href = requestCardChangeAndPay.data.url);
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage(
        "There was a problem generating your session. Please contact support if the problem persists."
      );
    }
  };
  return (
    <FadeIn  delay={350} duration={450}>
      <Row className='shadow pt-4 pb-4 mt-4 mb-4 prominentBox'>
        <Col className='mt-4'>
          <h3>You Might Have Overdue Payments</h3>
          <p>
            According to our records, you might have overdue payments or a payment has otherwise
            failed. Please click &quot;View/Pay&quot; to check each of these bills has been paid and
            correct the problem if there is one. Please do not hesitate to contact us if you have
            any questions.
          </p>
          {unpaidInvoicesList.length > 0 ? (
            <Table striped bordered hover responsive className='text-center'>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Update &amp; Pay</th>
                  <th>View/Pay Only</th>
                </tr>
              </thead>
              <tbody>
                {unpaidInvoicesList.map((Invoice) => (
                  <tr key={Invoice.id}>
                    <td>
                      <small>
                        <Moment unix format='YYYY/MM/DD'>{Invoice.created}</Moment>
                      </small>
                    </td>
                    <td>
                      <small>
                        {currencySymbol + parseFloat(Invoice.amount_due / 100).toFixed(2)}
                      </small>
                    </td>
                    <td>
                      <Button
                        variant='primary'
                        size='sm'
                        type='button'
                        value={Invoice.subscription}
                        onClick={(e) => {
                          handleCardChangeAndPay(Invoice.subscription, Invoice.id, e);
                        }}
                        disabled={Invoice.metadata.isSubscription === "false"}
                      >
                        Update &amp; Pay <MdCreditCard />
                      </Button>
                    </td>
                    <td>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href={Invoice.hosted_invoice_url}
                      >
                        <Button
                          variant='primary'
                          size='sm'
                          type='button'
                          className='btn btn-sm btn-danger'
                        >
                          View/Pay Only
                        </Button>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>Loading...</p>
          )}
        </Col>
      </Row>
    </FadeIn>
  );
};

//Export
export default PayYourInvoce;
